import {CheckTypes} from './enums'

class Require{
	constructor(vueInstance) {
		this.id = 'require_' + Math.random()
	    this.nodes = new Map()
		this.vueInstance = vueInstance
	}
	
	add(ref = '', rules = [], overwrite = false){
		if(ref && rules){
			const existedRules = this.nodes.get(ref)
			if(Array.isArray(rules)){
				rules.forEach(rule => rule.set(this.id, ref))
			}else{
				rules.set(this.id, ref)
			}
			if(existedRules){
				overwrite && (existedRules.length = 0)
				if(Array.isArray(rules)){
					existedRules.push(...rules)
				}else{
					existedRules.push(rules)
				}
			}else{
				this.nodes.set(ref, Array.isArray(rules) ? rules : [rules])
			}
		}
		return this
	}
	
	check(handler){
		let rs = 0
		for(let rules of this.nodes){
			let i = 0
			for(i; i < rules[1].length; i ++){
				const rule = rules[1][i]
				const result = rule.checkValue(this.vueInstance)
				if(!result){
					++ rs
					this.vueInstance.$refs[rule.ref].setErrorMessage(rule.message)
				}
			}
		}
		if(rs === 0){
			handler && handler()
		}
		return rs === 0
	}
}

class Rule{
	constructor(check = '', message = '') {
	    this.id = ''
		this.check = check
		this.message = message
	}
	
	set(requireId, ref){
		this.id = [requireId, 'item', Math.random()].join('-')
		this.ref = ref
	}
	
	check(){
		return true
	}
}

class RequireRule extends Rule{
	constructor({message}) {
	    super(CheckTypes.REQUIRE, message)
	}
	
	checkValue(vueInstance){
		const value = (vueInstance.$refs[this.ref].value || '').trim()
		if(value === ''){
			return false
		}
		return true
	}
}

class MobileRule extends Rule{
	constructor({message}) {
	    super(CheckTypes.MOBILE, message)
	}
	
	checkValue(vueInstance){
		const value = (vueInstance.$refs[this.ref].value || '').trim()
		return /^1[3456789]\d{9}$/.test(value)
	}
}

class LengthRule extends Rule{
	constructor({len = 0, range = '=', message}) {
	    super(CheckTypes.MOBILE, message)
		this.len = len
		this.range = range
	}
	
	checkValue(vueInstance){
		const value = (String(vueInstance.$refs[this.ref].value || '')).trim()
		console.log(value, this.len, this.range)
		if(this.range === '='){
			return value.length === Number.parseInt(this.len)
		}else if(this.range === '>'){
			return value.length > Number.parseInt(this.len)
		}else if(this.range === '>='){
			return value.length >= Number.parseInt(this.len)
		}else if(this.range === '<'){
			return value.length < Number.parseInt(this.len)
		}else if(this.range === '<='){
			return value.length <= Number.parseInt(this.len)
		}else if(this.range.toLowerCase() === 'in' && Array.isArray(this.len)){
			const [start, end] = this.len
			return value.length >= Number.parseInt(start) && value.length <= Number.parseInt(end)
		}
		return false
	}
}

class MailRule extends Rule{
	constructor({message}) {
	    super(CheckTypes.MAIL, message)
	}
	
	checkValue(vueInstance){
		const value = (vueInstance.$refs[this.ref].value || '').trim()
		return /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9|-]+\.([a-zA-Z]{2,4})$/.test(value)
	}
}

class UserDefinedRule extends Rule{
	constructor({message, handler}){
		super(CheckTypes.USER_DEFINED, message)
		this.handler = handler
	}
	
	checkValue(vueInstance){
		const value = (vueInstance.$refs[this.ref].value || '').trim()
		return this.handler ? this.handler(value) : true
	}
}

Object.assign(Require, {
	RequireRule,
	MobileRule,
	LengthRule,
	MailRule,
	UserDefinedRule
})

export default Require